const DECIMAL = /^(-?)(\d*)(?:\.(\d*))?$/;

/**
 * Convert what an operator typed ("49.99") to integer cents (4999).
 *
 * Strict by design: the result becomes a PUBLISHED plan-version price, so
 * anything that is not a plain decimal number ("abc", "12abc", "1e3", "1,000",
 * "1.2.3", ".", "-") is null, never a partial read. Empty / whitespace /
 * null / undefined is also null (the null-not-zero invariant: "no value" is
 * not "$0"). The caller decides what null means; PlanCard restores the saved
 * price rather than publish it.
 *
 * String-based so a third decimal rounds half-up on the magnitude exactly
 * ("1.005" -> 101, "-1.005" -> -101) without IEEE 754 float error. An amount
 * too large to hold exactly in cents is null.
 *
 * @param {string|number|null|undefined} dollars
 * @returns {number|null}
 */
export function dollarsToCents(dollars) {
    if (dollars === null || dollars === undefined) return null;
    const s = String(dollars).trim();
    if (s === "") return null;

    const m = DECIMAL.exec(s);
    if (!m) return null;
    const [, sign, intStr, fracStr = ""] = m;
    if (intStr === "" && fracStr === "") return null; // ".", "-", "-."

    const dollarsPart = intStr === "" ? 0 : Number(intStr);
    if (!Number.isSafeInteger(dollarsPart) || dollarsPart > Math.floor(Number.MAX_SAFE_INTEGER / 100) - 1) {
        return null;
    }

    const padded = (fracStr + "000").slice(0, 3);
    const centDigits = parseInt(padded.slice(0, 2), 10);
    const roundUp = parseInt(padded[2], 10) >= 5 ? 1 : 0;
    const magnitude = dollarsPart * 100 + centDigits + roundUp;
    return sign === "-" && magnitude !== 0 ? -magnitude : magnitude;
}
